export default "__VITE_ASSET__2ed53ba0__"